import { apiClient } from "./client";

export interface MetricsHourly {
  ts: string;
  plan_power_kw: number | string | null;
  plan_gas_m3: number | string | null;
  plan_cost_uah: number | string | null;
  plan_revenue_uah: number | string | null;
  plan_profit_uah: number | string | null;
  plan_volumes: Record<string, number> | null;
  fact_power_kw: number | string | null;
  fact_generation_kwh: number | string | null;
  fact_self_needs_kwh: number | string | null;
  fact_gas_m3: number | string | null;
  fact_cost_uah: number | string | null;
  fact_revenue_uah: number | string | null;
  fact_profit_uah: number | string | null;
  fact_volumes: Record<string, number> | null;
  balance_delta_kwh: number | string | null;
  balance_delta_pct: number | string | null;
  balance_ok: boolean | null;
  imbalance_kwh: number | string | null;
  imbalance_payment_uah: number | string | null;
  fact_heat_gcal: number | string | null;
  fact_heat_revenue_uah: number | string | null;
  heat_balance_delta_gcal: number | string | null;
  heat_balance_delta_pct: number | string | null;
  heat_balance_ok: boolean | null;
  recommended_power_kw: number | string | null;
  recommended_profit_uah: number | string | null;
  had_warning: boolean | null;
  had_alarm: boolean | null;
  direction_anomaly: boolean;
}

export interface DailyAgg {
  day: string;
  plan_revenue_uah: number | string | null;
  fact_revenue_uah: number | string | null;
  plan_profit_uah: number | string | null;
  fact_profit_uah: number | string | null;
  fact_generation_kwh: number | string | null;
  fact_hours: number;
  plan_volume_rdn: number | string | null;
  fact_volume_rdn: number | string | null;
  plan_volume_ekosfera: number | string | null;
  fact_volume_ekosfera: number | string | null;
  fact_heat_gcal: number | string | null;
  fact_heat_revenue_uah: number | string | null;
  imbalance_payment_uah: number | string | null;
  balance_violations: number;
  alarm_hours: number;
}

export interface BalanceCheckHour {
  ts: string;
  balance_ok: boolean | null;
  balance_delta_kwh: number | string | null;
  balance_delta_pct: number | string | null;
  heat_balance_ok: boolean | null;
  heat_balance_delta_pct: number | string | null;
  direction_anomaly: boolean;
}

export const metricsApi = {
  hourly: (date: string) =>
    apiClient
      .get<MetricsHourly[]>("/metrics/hourly", { params: { date } })
      .then((r) => r.data),

  daily: (from: string, to: string) =>
    apiClient
      .get<DailyAgg[]>("/metrics/daily", { params: { from, to } })
      .then((r) => r.data),

  balanceCheck: (date: string) =>
    apiClient
      .get<BalanceCheckHour[]>("/metrics/balance-check", { params: { date } })
      .then((r) => r.data),
};
